import {useSelector} from 'react-redux';
import {Navigate} from 'react-router-dom';

const GuestRoute = ({element}) => {
    const {isLoggedIn, user} = useSelector((state) => state.user);
    if (isLoggedIn && user) {
        if (user.verified)
            return <Navigate to="/panel"/>;
        return <Navigate to="/verifyOTP"/>;
    }
    return element

};

export default GuestRoute;
